// extracted by mini-css-extract-plugin
export default {"root":"KLOuB8leTllLPY2HfPrZ"};